<app-navbar></app-navbar>
<section class="focus">
  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-12">
        <div class="register-form">
          <app-register-form>
            <h1 class="ds-title-1">{{ 'no_survey.title' | translate }}</h1>
            <ng-container>
              <p class="ds-ui-1">{{ 'no_survey.p' | translate }}</p>
            </ng-container>
          </app-register-form>
          <app-swiss-made-footer></app-swiss-made-footer>
        </div>
      </div>
    </div>
  </div>
</section>
